/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CRMLeadListBody from "components/CRMComponents/CRMLeadListComponents/CRMLeadListBody/CRMLeadListBody";

const CrmLeadList = () => {
  useEffect(() => {
    document.title = "CRM Lead List";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <CRMLeadListBody />
    </main>
  );
};

export default CrmLeadList;
